import { render, staticRenderFns } from "./EditModalContact.vue?vue&type=template&id=f7c135a2&scoped=true"
import script from "./EditModalContact.vue?vue&type=script&lang=js"
export * from "./EditModalContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c135a2",
  null
  
)

export default component.exports